
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { AzureBlobDataset } from '../../model/dataset/azure-blob.dataset';
import { Metamodel } from 'app/model/base/model';
import { AzureStorageLinkedService } from 'app/model/linkedservice/azure-storage.linkedservice';
import { AzureBlobStorageLinkedService } from '../../model/linkedservice/azure-blob-storage.linkedservice';
import { maxConcurrentConnectionsMetadata, recursiveCheckboxMetadata, copyBehaviorMetadata } from '../consts/metadata-consts';
import { blobPathRegex } from 'app/shared/utils/connector-metadata-static-consts';

export const azureBlobDatasetMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(AzureBlobDataset).name,
    supportLinkedServiceTypes: [Metamodel.modelFor(AzureStorageLinkedService).name, Metamodel.modelFor(AzureBlobStorageLinkedService).name],
    displayName: stringResources.AzureBlobStorage_DisplayText,
    datasetKind: 'file',
    isSource: true,
    isSink: true,
    icon: {
        className: 'svg-i-100x100-AzureBlob'
    },
    isFirstClass: true,
    category: ['Azure'],
    supportGetMetadataActivity: true,
    supportRootFolder: false,
    pathRegex: blobPathRegex,
    supportDeleteActivity: true,
    supportIncrementalBinaryCopy: true,
    lookupActivityRequiredProperties: ['folderPath'],
    copySourceControls: [
        recursiveCheckboxMetadata,
        maxConcurrentConnectionsMetadata
    ],
    copySourceRequiredProperties: ['folderPath'],
    copySinkControls: [
        copyBehaviorMetadata,
        maxConcurrentConnectionsMetadata
    ],
    copySinkRequiredProperties: ['folderPath']
};
